import { ORDER } from "./order.enum";

export class GridSort {
  constructor(
    public field: string = "",
    public order: string = "",
  ) {}

  public getNumericOrder(): number {
    if (this.order === "") {
      return 0;
    }

    return ORDER[this.order];
  }
}
